import { StoreState } from '../types';

import { PermissionsState } from './types';

export const getPermissionsState = (state: StoreState): PermissionsState =>
  state.permissions;
